import { env } from './env';

export const GRID_PAGE_SIZES = [10, 20, 50, 100] as const;

export const DEFAULT_GRID_PAGE_SIZE = env.defaultPageSize;

export type BottoGridPagingOptions = {
  pageSize?: number;
  allowedPageSizes?: readonly number[];
  showInfo?: boolean;
  showPageSizeSelector?: boolean;
  showNavigationButtons?: boolean;
  enabled?: boolean;
  displayMode?: 'adaptive' | 'compact' | 'full';
};

/**
 * Build DataGrid `paging` + `pager` option objects.
 * Prefer these props over nested `<DxPaging>`/`<DxPager>` inside a Vue wrapper —
 * DevExtreme only discovers configuration components that are direct children of DxDataGrid.
 */
export function bottoGridPaging(opts: BottoGridPagingOptions = {}) {
  const enabled = opts.enabled ?? true;
  const pageSize = opts.pageSize ?? DEFAULT_GRID_PAGE_SIZE;
  const allowedPageSizes = [...(opts.allowedPageSizes ?? GRID_PAGE_SIZES)];

  return {
    paging: {
      enabled,
      pageSize,
    },
    pager: {
      visible: enabled,
      displayMode: opts.displayMode ?? 'full',
      showInfo: opts.showInfo ?? true,
      showPageSizeSelector: opts.showPageSizeSelector ?? true,
      allowedPageSizes,
      showNavigationButtons: opts.showNavigationButtons ?? true,
    },
  };
}
